.vc-reply-timestamp {
    margin-right: 0.25em;
}
